import React, { useMemo } from 'react';

interface IObserverProps {
    dishesArray: any[],
    analyticsHandler: (dish: any) => void,
}

const observerOptions = {
    rootMargin: '0px',
    threshold: 0.45,
};

export const useProductImpressionObserver = ({
    dishesArray,
    analyticsHandler,
}: IObserverProps) => {
    const dishObserver = useMemo(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
                if (e.isIntersecting) {
                    const isProgrammaticScrollFlag = sessionStorage.getItem('isProgrammaticScroll');
                    const isProgrammaticScroll = isProgrammaticScrollFlag
                        ? JSON.parse(isProgrammaticScrollFlag)
                        : false;
                    if (isProgrammaticScroll) return;
                    const target = e.target as HTMLElement;
                    const intersectingDish = dishesArray
                        .filter((dish) => dish.id === target.dataset.id);
                    analyticsHandler(intersectingDish);
                }
            });
        }, observerOptions);
        return observer;
    }, [dishesArray, analyticsHandler]);
    return [dishObserver];
};
